export default [
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/menu/public/faq.vue'),
    meta: {
      pageTitle: 'مدیریت سوالات متداول',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details',
    name: 'addfaq',
    component: () => import('@/views/menu/public/faqdetails.vue'),
    meta: {
      pageTitle: 'ایجاد سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details/:id',
    name: 'updatefaq',
    component: () => import('@/views/menu/public/faqdetails.vue'),
    meta: {
      pageTitle: 'ویرایش سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faqcategory',
    name: 'faqcategory',
    component: () => import('@/views/menu/public/faqcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های سوالات متداول',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details',
    name: 'addfaqcategory',
    component: () => import('@/views/menu/public/faqcategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faqcategory/details/:id',
    name: 'updatefaqcategory',
    component: () => import('@/views/menu/public/faqcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/sickness',
    name: 'sickness',
    component: () => import('@/views/menu/public/sickness.vue'),
    meta: {
      pageTitle: 'مدیریت بیماری ها',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sickness/details',
    name: 'addsickness',
    component: () => import('@/views/menu/public/sicknessdetails.vue'),
    meta: {
      pageTitle: 'ایجاد بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sickness/details/:id',
    name: 'updatesickness',
    component: () => import('@/views/menu/public/sicknessdetails.vue'),
    meta: {
      pageTitle: 'ویرایش بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },


  {
    path: '/sicknesscategory',
    name: 'sicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategory.vue'),
    meta: {
      pageTitle: 'مدیریت بیماری ها',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sicknesscategory/details',
    name: 'addsicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sicknesscategory/details/:id',
    name: 'updatesicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },



  {
    path: '/content',
    name: 'content',
    component: () => import('@/views/menu/public/content.vue'),
    meta: {
      pageTitle: 'مدیریت محتواها',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/content/details',
    name: 'addcontent',
    component: () => import('@/views/menu/public/contentdetails.vue'),
    meta: {
      pageTitle: 'ایجاد محتوا',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/content/details/:id',
    name: 'updatecontent',
    component: () => import('@/views/menu/public/contentdetails.vue'),
    meta: {
      pageTitle: 'ویرایش محتوا',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/version',
    name: 'version',
    component: () => import('@/views/menu/public/version.vue'),
    meta: {
      pageTitle: 'مدیریت ورژن ها',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/version/details',
    name: 'addversion',
    component: () => import('@/views/menu/public/versiondetails.vue'),
    meta: {
      pageTitle: 'ایجاد ورژن',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/version/details/:id',
    name: 'updateversion',
    component: () => import('@/views/menu/public/versiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش ورژن',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/shorturl',
    name: 'shorturl',
    component: () => import('@/views/menu/public/shorturl.vue'),
    meta: {
      pageTitle: 'مدیریت لینک ها',
      action: 'show',
      resource: 'ShortUrlManager',
    },
  },

  {
    path: '/file-manager',
    name: 'fileManager',
    component: () => import('@/views/menu/file-manager/file-manager.vue'),
    meta: {
      pageTitle: 'مدیریت فایل',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  // {
  //   path: '/report',
  //   name: 'report',
  //   component: () => import('@/views/menu/public/report.vue'),
  //   meta: {
  //     pageTitle: 'مدیریت گزارش ها',
  //     action: 'show',
  //     resource: 'ReportManager',
  //   },
  // },
  // {
  //   path: '/report/details/:id',
  //   name: 'updatereport',
  //   component: () => import('@/views/menu/public/reportdetails.vue'),
  //   meta: {
  //     pageTitle: 'ویرایش گزارش',
  //     action: 'show',
  //     resource: 'VersionManager',
  //   },
  // },
]
